/*
    EVENTS:

subscribe-modal-view-next: {
    emmeteur: [src/components/page/Feeds/SubscribeModal/ird-box-select.vue]
    receiver: [
        src/components/page/Feeds/SubscribeModal/index.vue,
    ]
}
*/



import Vue from 'vue';
export default new Vue();



// WEBPACK FOOTER //
// ./src/eventBus.js